module.exports = __webpack_public_path__ + "static/media/marker_scissors_hover.d6ed63fe.svg";